<ng-container *ngIf="isMobileDisplay">
    <div class="block-wrapper" [class.selected]="isSelected" [class.mobile]="isMobileDisplay">
        <div class="content-wrapper">
            <div class="session-exercice session-exercice-repeat">
                <div class="header">
                    <div fxLayout="row" fxLayoutAlign="center center" >
                        <div class="title">
                            {{ data.data.exercice.exercice.name }}
                        </div>
                        <div>
                            <app-chat-share [organization]="organization" [sessionId]="sessionId!" [sharable]="data.data.exercice.exercice">
                                <button mat-icon-button matTooltip="{{ 'Share' | translate }}">
                                    <mat-icon>share</mat-icon>
                                </button>
                            </app-chat-share>
                        </div>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
                    <div class="accents">
                        <div class="accent" *ngFor="let category of data.data.exercice.categories">
                            <exercice-category-thumbnail *ngIf="category !== null" [data]="category" [isMobileDisplay]="isMobileDisplay" [showAsTag]="true"></exercice-category-thumbnail>
                        </div>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
                    <div class="media" *ngIf="data.data.exercice.exerciceImage || data.data.exercice.exercice.video_path|| data.data.exercice.exercice.video_url">
                        <div class="image">
                            <img *ngIf="data.data.exercice.exerciceImage || conf.storageRootUrl + data.data.exercice.exercice.video_thumbnail_path" [src]="data.data.exercice.exerciceImage || conf.storageRootUrl + data.data.exercice.exercice.video_thumbnail_path" />
                        </div>

                        <exercices-video-button *ngIf="data.data.exercice.exercice.video_path|| data.data.exercice.exercice.video_url"
                                                class="play-video-button"
                                                [exercice]="data.data.exercice.exercice">
                        </exercices-video-button>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
                    <div class="description">
                        {{ data.data.exercice.exercice.description }}
                    </div>
                </div>

                <div class="summary">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div fxFlex="50" class="item">
                            <div class="title">{{ 'seriePlaceholder' | translate }}</div>
                            <div class="value">{{ data.data.sessionItemExercice.nbSerie }} x</div>
                        </div>
                        <div  fxFlex="50" class="item">
                            <div class="title">{{ 'payloadPlaceholder' | translate }}</div>
                            <div class="value">{{ data.data.sessionItemExercice.payload }} {{ sessionsProvider.SESSION_EXERCICE_PAYLOAD_UNIT }}</div>
                        </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div  fxFlex="50" class="item">
                            <div class="title">{{ 'repeatPlaceholder' | translate }}</div>
                            <div class="value">{{ data.data.sessionItemExercice.nbRepeat }} x</div>
                        </div>
                        <div  fxFlex="50" class="item">
                            <div class="title">{{ 'restTimePlaceholderAlt' | translate }}</div>
                            <div class="value">{{ _restTime | durationVerbose:'seconds' }}</div>
                        </div>
                    </div>
                </div>

                <div *ngIf="data.data.sessionItemExercice.comment" class="comment-container">
                    <div class="comment">{{ data.data.sessionItemExercice.comment }}</div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="!isMobileDisplay">

    <div class="block-wrapper" [class.selected]="isSelected" [class.mobile]="isMobileDisplay">
        <div class="content-wrapper">
            <div class="session-exercice session-exercice-repeat">
                <div class="header" *ngIf="!basicDisplay">
                    <div fxLayout="row" fxLayoutAlign="space-between center" >
                        <div class="title">
                            {{ data.data.exercice.exercice.name }}
                        </div>
                        <div *ngIf="isEditable" class="right-items">
                            <button mat-icon-button *ngIf="!itsTheFirst"
                                    [matTooltip]="'Move_up' | translate"
                                    (click)="moveup(data)">
                                <mat-icon>arrow_upward</mat-icon>
                            </button>
                            <button mat-icon-button *ngIf="!itsTheLast"
                                    [matTooltip]="'Move_down' | translate"
                                    (click)="movedown(data)">
                                <mat-icon>arrow_downward</mat-icon>
                            </button>

                            <button mat-icon-button [matMenuTriggerFor]="menu">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item
                                        [matTooltip]="'Duplicate' | translate"
                                        (click)="duplicate(data)">
                                    <mat-icon>filter_none</mat-icon>
                                    <span>{{ 'Duplicate' | translate}}</span>
                                </button>
                                <button mat-menu-item
                                        [matTooltip]="'Personalize' | translate"
                                        (click)="personalized(data)">
                                    <mat-icon>edit_outlined</mat-icon>
                                    <span>{{ 'Personalize' | translate}}</span>
                                </button>
                                <button mat-menu-item (click)="duplicateAsModel(data)">
                                    <mat-icon>book</mat-icon>
                                    <span>{{ 'Make_a_model' | translate}}</span>
                                </button>
                                <button mat-menu-item
                                        [matTooltip]="'Delete' | translate"
                                        (click)="delete(data)">
                                    <mat-icon>delete_outline</mat-icon>
                                    <span>{{ 'Delete' | translate}}</span>
                                </button>
                            </mat-menu>
                        </div>

                        <div *ngIf="!isEditable" class="right-items">
                            <button mat-icon-button
                                    [matTooltip]="(data.isCollapsed ? 'Open' : 'Close') | translate "
                                    (click)="data.isCollapsed = !data.isCollapsed">
                                <mat-icon>{{ data.isCollapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
                            </button>
                            <app-chat-share [organization]="organization" [sessionId]="sessionId!" [sharable]="getAsSharableType(data.data.exercice.exercice)">
                                <button mat-icon-button matTooltip="{{ 'Share' | translate }}">
                                    <mat-icon>share</mat-icon>
                                </button>
                            </app-chat-share>
                        </div>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="20px">
                    <div fxFlex="100">
                        <div *ngIf="!basicDisplay">
                            <div class="accents">
                                <div class="accent" *ngFor="let category of data.data.exercice.categories">
                                    <exercice-category-thumbnail *ngIf="category !== null" [data]="category" [showAsTag]="true"></exercice-category-thumbnail>
                                </div>
                            </div>
                            <ng-container *ngIf="isMobileDisplay">
                                <div class="media-mobile" *ngIf="data.data.exercice.exerciceImage || data.data.exercice.exercice.video_path|| data.data.exercice.exercice.video_url">
                                    <img *ngIf="data.data.exercice.exerciceImage || conf.storageRootUrl + data.data.exercice.exercice.video_thumbnail_path" [src]="data.data.exercice.exerciceImage || conf.storageRootUrl + data.data.exercice.exercice.video_thumbnail_path" />

                                    <ng-container *ngIf="isMobileDisplay">
                                        <exercices-video-button *ngIf="data.data.exercice.exercice.video_path|| data.data.exercice.exercice.video_url"
                                                                class="play-video-button"
                                                                [exercice]="data.data.exercice.exercice">
                                        </exercices-video-button>
                                    </ng-container>
                                </div>
                            </ng-container>

                            <div class="description">
                                {{ data.data.exercice.exercice.description }}
                            </div>
                        </div>

                        <ng-container *ngIf="!data.isCollapsed">
                            <div *ngIf="!isEditable" class="summary">
                                <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-between">
                                    <div  fxFlex="50" fxFlex.lt-sm="100">
                                        <div fxLayout="row" fxLayoutAlign="space-between start">
                                            <div  fxFlex="50">
                                                <div class="title">{{ 'seriePlaceholder' | translate }}</div>
                                                <div>{{ data.data.sessionItemExercice.nbSerie }} x</div>
                                            </div>
                                            <div  fxFlex="50">
                                                <div class="title">{{ 'payloadPlaceholder' | translate }}</div>
                                                <div>{{ data.data.sessionItemExercice.payload }} {{ sessionsProvider.SESSION_EXERCICE_PAYLOAD_UNIT }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div  fxFlex="50" fxFlex.lt-sm="100">
                                        <div fxLayout="row" fxLayoutAlign="space-between start">
                                            <div  fxFlex="50">
                                                <div class="title">{{ 'repeatPlaceholder' | translate }}</div>
                                                <div>{{ data.data.sessionItemExercice.nbRepeat }} x</div>
                                            </div>
                                            <div  fxFlex="50">
                                                <div class="title">{{ 'restTimePlaceholderAlt' | translate }}</div>
                                                <div>{{ _restTime | durationVerbose:'seconds' }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
</div>
                        </ng-container>

                        <div class="total-duration" [class.bold]="isEditable">
                            <div fxLayout="row" fxLayout.lt-sm="column-reverse" fxLayoutAlign="space-between start">
                                <div fxFlex="50">
                                    <div class="title" *ngIf="!isEditable">{{ 'totalTime' | translate }}</div>
                                    {{ _totalTime??0 | durationVerbose:'seconds' }}
                                </div>
                                <div fxFlex="50" *ngIf="isMobileDisplay">
                                    <div class="title" *ngIf="!isEditable">{{ 'totalPayload' | translate }}</div>
                                    {{ _totalPayload }} {{ sessionsProvider.SESSION_EXERCICE_PAYLOAD_UNIT | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <ng-container *ngIf="!isMobileDisplay && !basicDisplay">
                        <div class="media" *ngIf="data.data.exercice.exerciceImage || data.data.exercice.exercice.video_path|| data.data.exercice.exercice.video_url">
                            <img *ngIf="data.data.exercice.exerciceImage || conf.storageRootUrl + data.data.exercice.exercice.video_thumbnail_path" [src]="data.data.exercice.exerciceImage || conf.storageRootUrl + data.data.exercice.exercice.video_thumbnail_path" />

                            <exercices-video-button *ngIf="data.data.exercice.exercice.video_path|| data.data.exercice.exercice.video_url"
                                                    class="play-video-button"
                                                    [exercice]="data.data.exercice.exercice"
                                                    [iconOnly]="true"
                            >
                            </exercices-video-button>
                        </div>
                    </ng-container>
                </div>
<ng-container *ngIf="!isEditable">
                    <div *ngIf="data.data.sessionItemExercice.comment" class="comment-container">
                        <div class="comment">{{ data.data.sessionItemExercice.comment }}</div>
                    </div>
                </ng-container>
<ng-container *ngIf="!data.isCollapsed">
                    <div class="main-container">
                        <div class="left-container">

                            <!--<div *ngIf="isEditable"
                                 class="form">
                                <mat-form-field color="primary">
                                    <input matInput
                                           [(ngModel)]="data.data.sessionItemExercice.nbSerie"
                                           type="number"
                                           min="1"
                                           [placeholder]="'seriePlaceholder' | translate"
                                           (ngModelChange)="onNbSerieChange($event)"
                                            autocomplete="off">
                                </mat-form-field>
                                <mat-form-field color="primary">
                                    <input matInput
                                           [(ngModel)]="data.data.sessionItemExercice.payload"
                                           type="number"
                                           min="0"
                                           [placeholder]="'payloadPlaceholder' | translate"
                                           (ngModelChange)="calcTotalPayload()"
                                           autocomplete="off">
                                    <span matSuffix>{{ sessionsProvider.SESSION_EXERCICE_PAYLOAD_UNIT }}</span>
                                </mat-form-field>

                                <mat-form-field color="primary">
                                    <input matInput
                                           [(ngModel)]="data.data.sessionItemExercice.nbRepeat"
                                           type="number"
                                           min="1"
                                           [placeholder]="'repeatPlaceholder' | translate"
                                           (ngModelChange)="onNbRepeatChange($event)"
                                           autocomplete="off">
                                </mat-form-field>
                                &lt;!&ndash;
                                <mat-form-field color="primary"
                                                [hintLabel]="'time_format_hour_minute' | translate">
                                    <input matInput
                                           [(ngModel)]="_duration"
                                           type="text"
                                           [placeholder]="'repetitionDurationPlaceholder' | translate"
                                           (ngModelChange)="onDurationChange($event)">
                                </mat-form-field>
                                <mat-form-field color="primary"
                                                [hintLabel]="'time_format_hour_minute' | translate">
                                    <input matInput
                                           [(ngModel)]="_restTime"
                                           type="text"
                                           [placeholder]="'restTimePlaceholderAlt' | translate"
                                           (ngModelChange)="onRestTimeChange($event)">
                                </mat-form-field>
                                    &ndash;&gt;
                                <duration-control [(value)]="data.data.sessionItemExercice.duration"
                                                  [label]="'repetitionDurationPlaceholder' | translate"
                                                  [displayMode]="'ms'"
                                                  (change)="onDurationChange($event)"
                                                  >
                                </duration-control>
                                <duration-control [(value)]="data.data.sessionItemExercice.restTime"
                                                  [label]="'restTimePlaceholderAlt' | translate"
                                                  [displayMode]="'ms'"
                                                  (change)="onRestTimeChange($event)"
                                                  >
                                </duration-control>
                            </div>-->

                            <!--<div *ngIf="isEditable"
                                 class="summary">
                                <div class="item">
                                    <div class="title bold">{{ 'totalTime' | translate }}</div>
                                    <div>{{ _totalTime | durationVerbose:'seconds' }}</div>
                                </div>
                                <div class="item">
                                    <div class="title bold">{{ 'totalPayload' | translate }}</div>
                                    <div>{{ _totalPayload }}{{ sessionsProvider.SESSION_EXERCICE_PAYLOAD_UNIT | translate }}</div>
                                </div>
                            </div>-->
                        </div>

                    </div>
                    <div class="comment">
                        <!--<mat-form-field *ngIf="isEditable"
                                        color="primary">
                            <textarea matInput
                                      matTextareaAutosize
                                      [(ngModel)]="data.data.sessionItemExercice.comment"
                                      [placeholder]="'coachComment' | translate"
                                      (ngModelChange)="onCommentChange($event)"></textarea>
                        </mat-form-field>-->

                        <!--<div *ngIf="data.data.sessionItemExercice.comment" class="comment-container">
                            <div class="label">{{ 'coachComment' | translate }}</div>
                            <div class="comment">{{ data.data.sessionItemExercice.comment }}</div>
                        </div>-->
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="drag-handle" ngxDragHandle *ngIf="isEditable">
            <mat-icon>drag_indicator</mat-icon>
        </div>
    </div>

</ng-container>
